<template>
  <div
    class="finance-wrap"
    :style="'background:url(' + indata.bgcImage + ') no-repeat 50% 50%'"
  >
    <div class="finance-box">
      <div class="finance-left-box">
        <p class="h1">{{ indata.title1 }}</p>
        <ul class="finance-left-ul">
          <li v-for="(item, index) in indata.children" :key="index" v-if="item.lf==0">
            <i
              class="finance-1"
              :style="'background:url(' + item.image + ') no-repeat 50% 50%'"
            ></i>
            <p>{{ item.subTitle }}</p>
          </li>
        </ul>
      </div>
      <div class="finance-right-box">
        <div class="right-title">
          <p class="h1">{{ indata.title2 }}</p>
          <p class="detail">{{ indata.subTitle }}</p>
        </div>
        <ul class="finance-left-ul finance-right-ul">
          <i
            class="vs"
            :style="'background:url(' + indata.vsImage + ') no-repeat 50% 50%'"
          ></i>
          <li v-for="(item, index) in indata.children" :key="index" v-if="item.lf==1">
            
            <i
              class="finance-1"
              :style="'background:url(' + item.image + ') no-repeat 50% 50%'"
            ></i>
            <p>{{ item.subTitle }}</p>
          </li>
          <a class="go-next" target="_blank" :href="indata.btnUrl">立即注册</a>
          <div class="clear-both"></div>
        </ul>
      </div>
    </div>
  </div>
</template>


<style scoped src="../../public/css/cloudFinance.css">
</style>



<script>
export default {
  name: "Templates19",
  props: {
    indata: Array,
  },
  computed: {
    //这里设置banner 是在900像素下高度为200px，我的banner图格式为1920X900像素
    autoHeight() {
      let _w =
        document.documentElement.clientWidth || document.body.clientWidth;
      return (_w * 200) / 450 + "px";
    },
  },
  data() {
    return {
      NowIndex: 0,
    };
  },
  methods: {
    changeActive(index) {
      this.NowIndex = index;
    },
  },
};
</script>


